import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  getVisibleCostCenters,
  getFilters,
  getPagination,
  getIsLoading,
} from 'cost_centers/selectors';
import { getCompany, getSubcompany, getPermissions } from 'auth/selectors';

import * as CostCenters from 'cost_centers/components';
import CostCenterRowContainer from 'cost_centers/containers/CostCenterRowContainer';
import CostCentersListHandlers from 'cost_centers/containers/CostCentersListHandlers';
import { toggle } from 'cost_centers/actions'; ////////
import { addGrowlError as error, addGrowlSuccess as success } from 'messages/actions'; ////////

class CostCentersListContainer extends Component {
  renderRows = () =>
    this.props.costCenters.map((costCenter) => (
      <CostCenterRowContainer
        key={costCenter.id}
        costCenter={costCenter}
        handleToggle={this.handleToggle} ////////
      />
    ));

  ////////////////////
  handleToggle = (id) =>
    this.props
      .toggle(id, this.props.company.id, this.props.subcompany.id)
      .then(({ value }) => this.props.success(value.message))
      .catch((err) => this.props.error(err.message));

  render = () => (
    <CostCentersListHandlers
      render={({
        handleOrderChange,
        handleLimitChange,
        handlePageChange,
        handleFiltersChange,
        handleSubmit,
        columnSearch,
        handleToggleSearch, // Agregar
      }) => (
        <CostCenters.ListView
          count={this.props.costCenters.length}
          filters={this.props.filters}
          company={this.props.company}
          isLoading={this.props.isLoading}
          handleToggle={this.handleToggle} ////////////////////////
          handleOrderChange={handleOrderChange}
          handleSubmit={handleSubmit}
          columnSearch={columnSearch}
          handleToggleSearch={handleToggleSearch}
          handleFiltersChange={handleFiltersChange}
          handleLimitChange={handleLimitChange}
          handlePageChange={handlePageChange}
          subcompany={this.props.subcompany}
          pagination={this.props.pagination}
          permissions={this.props.permissions}
        >
          {this.renderRows()}
        </CostCenters.ListView>
      )}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  permissions: getPermissions(state),
  costCenters: getVisibleCostCenters(state),
  filters: getFilters(state),
  pagination: getPagination(state),
  isLoading: getIsLoading(state),
});
const mapDispatchToProps = { toggle, error, success }; ///////

export default connect(
  mapStateToProps,
  mapDispatchToProps //////////////
)(CostCentersListContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/containers/CostCentersListContainer.js